import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function endAtAfterStartAtValidator(startAtKey: string, endAtKey: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const startAt = group.get(startAtKey)?.value;
    const endAt = group.get(endAtKey)?.value;

    return startAt && endAt && endAt <= startAt ? { endAtBeforeStartAt: true } : null;
  };
}
